// `/campaigns` — list route (US-120).

import { createRoute } from '@tanstack/react-router';

import { CampaignsListPage } from '@/features/campaigns/CampaignsListPage';

import { Route as CampaignsLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => CampaignsLayoutRoute,
  path: '/',
  component: CampaignsIndex,
});

function CampaignsIndex() {
  return <CampaignsListPage />;
}
